import { Field, FieldLabel, FieldError } from '@HoudiniUI/Field';
import { ColorPicker } from '@HoudiniUI/ColorPicker';
import React from 'react';

interface ColorFieldProps {
	id: string;
	label: string;
	value: string | undefined;
	onChange: (color: string) => void;
	fallback?: string;
	error?: { message?: string };
}

export function ColorField({ id, label, value, onChange, fallback = '#000000', error }: ColorFieldProps) {
	const labelId = `${id}-label`;

	return (
		<Field>
			<FieldLabel id={labelId}>{label}</FieldLabel>
			<ColorPicker value={value || fallback} onChange={onChange} ariaLabelledBy={labelId} />
			<FieldError errors={error ? [error] : []} />
		</Field>
	);
}
